import type { CadenceDaySummary } from "../../api/cadence.ts";
import { cadenceMonthMetrics } from "../CadenceCalendar.helpers.ts";

export function CadenceMetrics({ days }: { days: CadenceDaySummary[] }) {
  const metrics = cadenceMonthMetrics(days);
  return (
    <section className="cadence-metrics" aria-label="Metricas do mes">
      <Metric label="Pendentes" value={metrics.pending} />
      <Metric label="Concluidas" value={metrics.done} />
      <Metric label="Atrasadas" value={metrics.late} tone={metrics.late ? "danger" : ""} />
      <Metric label="Total" value={metrics.total} />
    </section>
  );
}

function Metric({ label, value, tone = "" }: { label: string; value: number; tone?: string }) {
  return (
    <div className={`cadence-metric ${tone ? `is-${tone}` : ""}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}
